import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useApp();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const result = await login(username, password);
    if (result.success && result.user.role === 'admin') {
      navigate('/admin');
    } else if (result.success) {
      setError('Access denied. Admin credentials required.');
    } else {
      setError(result.message);
    }
  };

  return (
    <div style={styles.container}>
      <form onSubmit={handleSubmit} style={styles.form}>
        <h2 style={styles.title}>🔐 Admin Login</h2>
        <p style={styles.hint}>Demo: admin / admin123</p>
        {error && <div style={styles.error}>{error}</div>}
        <input style={styles.input} placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} required />
        <input style={styles.input} type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
        <button type="submit" style={styles.btn}>Login</button>
      </form>
    </div>
  );
}

const styles = {
  container: { minHeight: 'calc(100vh - 64px)', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f2f5' },
  form: { background: '#fff', padding: 40, borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.1)', width: '100%', maxWidth: 400 },
  title: { textAlign: 'center', marginBottom: 4 },
  hint: { textAlign: 'center', color: '#888', fontSize: 13, marginBottom: 20 },
  error: { background: '#fee', color: '#c0392b', padding: 10, borderRadius: 8, marginBottom: 12, fontSize: 13, textAlign: 'center' },
  input: { width: '100%', padding: 12, border: '2px solid #e0e0e0', borderRadius: 8, fontSize: 14, marginBottom: 12, boxSizing: 'border-box', outline: 'none' },
  btn: { width: '100%', padding: 12, background: '#1a1a2e', color: '#4ecca3', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700, cursor: 'pointer' },
};
